import type { BaseSyntheticEvent } from 'react';
import styled from 'styled-components';
import type {
  ContentDirection,
  FieldValue,
  FormStatus,
  FormThemeValue
} from '@elfsight/widget-form-builder/widget';
import { HorizontalLayout } from '@elfsight/widget-form-builder/widget';
import type { BuilderContentAlignment } from '../../Builder';
import { VerticalLayout } from './VerticalLayout';

export interface LayoutProps {
  isHorizontal: boolean;
  formSettings: any;
  theme: FormThemeValue;
  alignment?: BuilderContentAlignment;
  submitButtonAlignment?: 'left' | 'center' | 'right';
  contentDirection?: ContentDirection;
  status?: FormStatus;
  error?: string;
  handleSubmit(e: BaseSyntheticEvent): Promise<void>;
  handleFormChange: (value?: FieldValue) => void;
}

export const Layout = ({
  isHorizontal,
  formSettings,
  theme,
  handleSubmit,
  handleFormChange,
  alignment,
  contentDirection = 'column',
  submitButtonAlignment,
  status,
  error
}: LayoutProps) => {
  if (isHorizontal) {
    return (
      <HorizontalLayout
        formSettings={formSettings}
        theme={theme}
        handleSubmit={handleSubmit}
        hideErrors
        handleChange={handleFormChange}
        contentDirection={contentDirection}
      />
    );
  }

  return (
    <>
      <VerticalLayout
        theme={theme}
        formSettings={formSettings}
        handleSubmit={handleSubmit}
        alignment={alignment}
        contentDirection={contentDirection}
        submitButtonAlignment={submitButtonAlignment}
        status={status}
        handleChange={handleFormChange}
      />
      {['failed', 'invalid'].includes(status!) && (
        <ErrorsGroup>
          {error && <Error style={{ color: theme.errorColor }}>{error}</Error>}
        </ErrorsGroup>
      )}
    </>
  );
};

const Error = styled.div`
  font-size: 14px;
  line-height: 1.2;
`;
const ErrorsGroup = styled.div`
  margin-top: 12px;
`;
